// insurance-conditional-visibility.js
// Generic show/hide-by-install-choice primitive — mirrors DTC's window.updateSectionVisibility.
// Any element with [data-visible-when="always|with-install|no-install"] is toggled to match the
// wizard's install choice. Reads the wizard's checked radio directly on load rather than only
// trusting insurance:selection-changed — that event may already have fired (and been missed) by
// the time this script runs, e.g. for a returning visitor whose choice was restored on connect.

(() => {
  if (window.__insuranceVisibilityInit) return;
  window.__insuranceVisibilityInit = true;

  // No explicit choice yet still means something is showing on the page (the install step, unless
  // a partner forces otherwise) — default to 'yes' rather than showing neither with/no-install
  // variant. Applied everywhere an "install" value can be blank: the initial DOM read below, the
  // wizard's own selection-changed dispatch (blank on first load/restore, before any interaction),
  // and the geo-resolved fallback.
  const normalizeInstall = (install) => install || 'yes';

  // Mirrors insurance-wizard.js's installMode(): a forced partner (install_offered false) never
  // renders a choice radio at all, so read its forced value straight off the wizard's own data
  // attributes rather than the (nonexistent) radio.
  const currentInstall = () => {
    const wizard = document.querySelector('insurance-wizard');
    if (wizard && wizard.dataset.installOffered !== '1') return normalizeInstall(wizard?.dataset.forcedInstall);
    return normalizeInstall(document.querySelector('input[name^="install-choice"]:checked')?.value);
  };

  const apply = (install) => {
    document.querySelectorAll('[data-visible-when]').forEach((el) => {
      const rule = el.dataset.visibleWhen;
      const visible = rule === 'always'
        || (rule === 'with-install' && install === 'yes')
        || (rule === 'no-install' && install === 'no');
      el.hidden = !visible;
    });
  };

  document.addEventListener('insurance:selection-changed', (event) => apply(normalizeInstall(event.detail?.install)));
  // The geolocation gate can also decide install availability (a "no coverage" ZIP hides the
  // install step) without the shopper ever touching the radio. Mirrors insurance-wizard.js's own
  // onGeoResolved exactly: only a definitive "none" forces no-install; anything else re-derives
  // the wizard's actual current state (the wizard never auto-picks a choice on restore, so this
  // can genuinely land back on "no choice made yet", not necessarily 'yes').
  document.addEventListener('insurance:geo-resolved', (event) => {
    apply(event.detail?.status === 'none' ? 'no' : currentInstall());
  });
  apply(currentInstall());
})();
